import {OrderStatusType} from './store/order/types';
import {StepType} from './store/step/types';

export const MODULE_KEY = 'postPurchaseInsurance';

export const STATUS: {[key: string]: OrderStatusType} = {
    NOT_STARTED: 'Not-started',
    ACTIVE: 'Active',
    ENDED: 'Ended',
    FULLY_COVERED: 'Fully Covered',
} as const;

export const STEP: {[key: string]: StepType} = {
    ORDER: 'order',
    PAYMENT: 'payment',
    TYP: 'typ',
};

export const STEPS = {
    PAYMENT: 2,
    COMPLETED: 3,
};

export const DATA_DONOR = {
    INSURANCE: 'insurance',
    PRODUCT: 'product',
};
